import { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useLang } from "./hooks/useLang";
import Navbar from "./components/Navbar";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import RenewableSection from "./components/RenewableSection";
import FinancingSection from "./components/FinancingSection";
import BESSSection from "./components/BESSSection";
import ProjectsSection from "./components/ProjectsSection";
import HolyGrailTeaser from "./components/HolyGrailTeaser";
import NewsSection from "./components/NewsSection";
import PartnersSection from "./components/PartnersSection";
import ContactModal from "./components/ContactModal";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/sonner";
import { t } from "./translations";
import CookieBanner from "./components/CookieBanner";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import HolyGrailPage from "./pages/HolyGrailPage";
import CIEnergyPage from "./pages/CIEnergyPage";
import GPTransformersPage from "./pages/GPTransformersPage";
import TermsOfUse from "./pages/TermsOfUse";
import CookiePolicy from "./pages/CookiePolicy";
import SustainabilityPage from "./pages/SustainabilityPage";
import NotFoundPage from "./pages/NotFoundPage";

// Handles scroll-to-section when navigating back from another page
function ScrollToSection() {
  const location = useLocation();
  useEffect(() => {
    const id = location.state?.scrollTo;
    if (!id) return;
    const timer = setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    }, 150);
    return () => clearTimeout(timer);
    // id is derived from location.state (in deps); scrollIntoView is a DOM method
  }, [location.state]);
  return null;
}

const Landing = () => {
  const [lang, setLang]       = useLang();
  const [contactOpen, setContactOpen] = useState(false);
  const text = t[lang];

  return (
    <div className="bg-[#050505] text-white min-h-screen" style={{ fontFamily: "'Manrope', sans-serif" }}>
      <ScrollToSection />
      <Navbar text={text.nav} lang={lang} setLang={setLang} onContact={() => setContactOpen(true)} />
      <main>
        <HeroSection text={text.hero} onContact={() => setContactOpen(true)} />
        <AboutSection text={text.about} />
        <RenewableSection text={text.renewable} />
        <FinancingSection text={text.financing} />
        <BESSSection text={text.bess} />
        <HolyGrailTeaser lang={lang} />
        <ProjectsSection text={text.projects} />
        <PartnersSection text={text.partners} />
        <NewsSection text={text.news} />
      </main>
      <Footer text={text.footer} onContact={() => setContactOpen(true)} />
      <ContactModal open={contactOpen} onClose={() => setContactOpen(false)} text={text.contact} lang={lang} />
      <Toaster theme="dark" position="top-right" />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermsOfUse />} />
        <Route path="/cookies" element={<CookiePolicy />} />
        <Route path="/sustainability" element={<SustainabilityPage />} />
        <Route path="/holy-grail" element={<HolyGrailPage />} />
        <Route path="/ci-energy" element={<CIEnergyPage />} />
        <Route path="/gp-transformers" element={<GPTransformersPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      <CookieBanner />
    </BrowserRouter>
  );
}

export default App;
